export default __webpack_public_path__ + "7f983a513da38b0181bffd8b06c87593.svg";